import {
  createLightTheme,
  type BrandVariants,
  type Theme,
} from '@fluentui/react-components';

/**
 * Fluent brand ramp generated around the Syaa logo blue (#1946B9), which lands
 * at slot 80 — the slot Fluent uses for primary button fills. The ramp keeps the
 * portal's structure while the product still reads as ours rather than as stock
 * Microsoft blue.
 */
export const syaaBrand: BrandVariants = {
  10: '#020306',
  20: '#101627',
  30: '#152143',
  40: '#182B5C',
  50: '#1A3576',
  60: '#1B3F91',
  70: '#1A4AAD',
  80: '#1946B9',
  90: '#3A63C7',
  100: '#5479D1',
  110: '#6E8FDB',
  120: '#88A5E4',
  130: '#A3BBEC',
  140: '#BED1F3',
  150: '#D9E4F9',
  160: '#F0F4FD',
};

/** Light only — the portal's default, and what was asked for. */
export const syaaLightTheme: Theme = {
  ...createLightTheme(syaaBrand),
  // Azure's canvas is a touch warmer than Fluent's default white.
  colorNeutralBackground3: '#faf9f8',
};

/** The dark bar across the top of the portal. */
export const HEADER_BACKGROUND = '#10275e';
